module.exports = __webpack_public_path__ + "img/riparian_info_landing_overlay.c0ad149d.png";